import { useQuery } from 'react-query'
import { useAuth } from '@/providers/auth'
import { usePermission } from '@/providers/permissions'
import { companyConfigQueryKey, fetchCompanyConfig } from '@/lib/companies'

export function useCompanyConfig() {
  const { company } = useAuth()
  const { hasPermission } = usePermission()
  return useQuery(companyConfigQueryKey(company.id), () => fetchCompanyConfig(company.id), {
    enabled: !!company.id && hasPermission('settings', 'read'),
    staleTime: 60_000,
    refetchOnWindowFocus: false
  })
}
